import queryString from "query-string";
const joinLinkFor = (alias, channel, query) => {
    let link = `${process.env.REACT_APP_WITHFRIENDS_HOST}/${alias}/join`;
    const baseQuery = queryString.stringify(query);
    if (channel) {
        link = `${link}:channel=${channel}`;
    }
    if (baseQuery) {
        link = `${link}?${queryString.stringify(query)}`;
    }
    return link.toLowerCase();
};
const shortLinkFor = (alias, channel) => {
    const domain = { 'online': 'wfr.app', 'instore': 'wfr.link' }[channel];
    const shortAlias = alias.replace(/_/g, '');
    const link = `https://${domain}/${shortAlias}`;
    return link.toLowerCase();
};
const irlLinkFor = (alias) => {
    const link = `${process.env.REACT_APP_WITHFRIENDS_HOST}/${alias}/irl`;
    return link.toLowerCase();
};
const customizeTabletLinkFor = (alias) => {
    const link = `${process.env.REACT_APP_WITHFRIENDS_HOST}/${alias}/send_to_tablet/modal`;
    return link.toLowerCase();
};
const customRedirectLinkFor = (alias) => {
    const link = `${process.env.REACT_APP_WITHFRIENDS_HOST}/greet/:f=custom,b=${alias}`;
    return link.toLowerCase();
};
const orderEmailAddressFor = (alias) => {
    const link = `orders+${alias}@withfriends.co`;
    return link.toLowerCase();
};
const posterQRFor = (alias) => {
    const link = `${process.env.REACT_APP_WITHFRIENDS_HOST}/${alias}/qr:channel=Poster,no_logo`;
    return link;
};
const contactTracingQRFor = (alias) => {
    const link = `${process.env.REACT_APP_WITHFRIENDS_HOST}/${alias}/qr:contact_tracing`;
    return link;
};
export { joinLinkFor, shortLinkFor, irlLinkFor, customRedirectLinkFor, orderEmailAddressFor, customizeTabletLinkFor, posterQRFor, contactTracingQRFor };
